// A no-operation function that does nothing
export const noop = () => {
  // Intentionally left blank
}
